import { Record, Union } from "../../fable_modules/fable-library-js.4.19.0/Types.js";
import { option_type, record_type, bool_type, class_type, union_type, string_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { BoolResult_$reflection } from "../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.0/Result.js";
import { GlobalMsg_$reflection } from "../../../Bfs.Web.Portale/Types.fs.js";
import { FormField__get_IsValid, ValidationRule, FormField_Init_Z1F39563A, FormField_$reflection } from "../../../Bfs.Web.Portale/Validation.fs.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LostPassword", "ResetPassword", "MessagePage"];
    }
}

export function Page_$reflection() {
    return union_type("Password.Types.Page", [], Page, () => [[], [["Item", string_type]], [["Item", string_type]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EmailChanged", "PasswordChanged", "Password2Changed", "CheckToken", "TokenChecked", "Submit", "Submitted", "ShowMsg", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Password.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [BoolResult_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", BoolResult_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]]), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", GlobalMsg_$reflection()]]]);
}

export class LostPasswordModel extends Record {
    constructor(Email, Sending, IsFinished) {
        super();
        this.Email = Email;
        this.Sending = Sending;
        this.IsFinished = IsFinished;
    }
}

export function LostPasswordModel_$reflection() {
    return record_type("Password.Types.LostPasswordModel", [], LostPasswordModel, () => [["Email", FormField_$reflection()], ["Sending", bool_type], ["IsFinished", bool_type]]);
}

export function LostPasswordModel_Init() {
    return new LostPasswordModel(FormField_Init_Z1F39563A(new ValidationRule(0, [])), false, false);
}

export function LostPasswordModel__get_CanSubmit(x) {
    if (!x.Sending) {
        return FormField__get_IsValid(x.Email);
    }
    else {
        return false;
    }
}

export class ResetPasswordModel extends Record {
    constructor(Password, Password2, Token, Message, Sending, IsFinished) {
        super();
        this.Password = Password;
        this.Password2 = Password2;
        this.Token = Token;
        this.Message = Message;
        this.Sending = Sending;
        this.IsFinished = IsFinished;
    }
}

export function ResetPasswordModel_$reflection() {
    return record_type("Password.Types.ResetPasswordModel", [], ResetPasswordModel, () => [["Password", FormField_$reflection()], ["Password2", FormField_$reflection()], ["Token", string_type], ["Message", option_type(string_type)], ["Sending", bool_type], ["IsFinished", bool_type]]);
}

export function ResetPasswordModel_Init_Z721C83C5(token) {
    return new ResetPasswordModel(FormField_Init_Z1F39563A(new ValidationRule(0, [])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), token, undefined, false, false);
}

export function ResetPasswordModel__get_CanSubmit(x) {
    if (!x.Sending && FormField__get_IsValid(x.Password)) {
        return FormField__get_IsValid(x.Password2);
    }
    else {
        return false;
    }
}

export class MessageModel extends Record {
    constructor(Text$) {
        super();
        this.Text = Text$;
    }
}

export function MessageModel_$reflection() {
    return record_type("Password.Types.MessageModel", [], MessageModel, () => [["Text", string_type]]);
}

export function MessageModel_Init_Z721C83C5(text) {
    return new MessageModel(text);
}

export class Model extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LostPasswordModel", "ResetPasswordModel", "MessageModel"];
    }
}

export function Model_$reflection() {
    return union_type("Password.Types.Model", [], Model, () => [[["Item", LostPasswordModel_$reflection()]], [["Item", ResetPasswordModel_$reflection()]], [["Item", MessageModel_$reflection()]]]);
}

export function Model__get_CanSubmit(x) {
    switch (x.tag) {
        case 0:
            return LostPasswordModel__get_CanSubmit(x.fields[0]);
        case 1:
            return ResetPasswordModel__get_CanSubmit(x.fields[0]);
        default:
            return false;
    }
}

//# sourceMappingURL=Types.fs.js.map
